import failure from '@/assets/images/failure.svg';
import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateGraphic,
  EmptyStateTitle,
  Image,
  Link,
} from '@customerio/pluma-components/react';

export const ErrorPage = () => {
  return (
    <EmptyState>
      <EmptyStateGraphic>
        <Image src={failure} width={80} height={80} alt="" role="presentation" />
      </EmptyStateGraphic>
      <EmptyStateTitle>Whoops!</EmptyStateTitle>
      <EmptyStateDescription>
        There was a problem loading this page. If this problem continues,{' '}
        <Link href="mailto:win@customer.io" isExternal={true} variant="secondary">
          please contact our support team
        </Link>
        .
      </EmptyStateDescription>
    </EmptyState>
  );
};
